import { render, staticRenderFns } from "./ManifestoComponent.vue?vue&type=template&id=3bcd8688&scoped=true&"
import script from "./ManifestoComponent.vue?vue&type=script&lang=js&"
export * from "./ManifestoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd8688",
  null
  
)

export default component.exports